// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Amount$LiveRoom from "../Amount.bs.js";
import * as I18next$LiveRoom from "../bindings/I18next.bs.js";
import * as PropSpread$LiveRoom from "./PropSpread.bs.js";
import * as Utils_Shared$LiveRoom from "../Utils/Utils_Shared.bs.js";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";
import * as SterlingTypography$LiveRoom from "../bindings/SterlingTypography.bs.js";
import * as AlternativeCurrency$LiveRoom from "../stores/AlternativeCurrency.bs.js";

function LotCardPrice$Layout(props) {
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.display("flex"),
                    tl: {
                      hd: Css.justifyContent("spaceBetween"),
                      tl: /* [] */0
                    }
                  })
            }, props.children);
}

var Layout = {
  make: LotCardPrice$Layout
};

function LotCardPrice$Label(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return React.createElement(PropSpread$LiveRoom.make, {
              data: {
                hd: {
                  TAG: /* TestId */1,
                  _0: props.testId
                },
                tl: /* [] */0
              },
              children: React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                    className: Curry._1(Css.merge, {
                          hd: Curry._1(Css.style, {
                                hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                                tl: /* [] */0
                              }),
                          tl: {
                            hd: className$1,
                            tl: /* [] */0
                          }
                        }),
                    children: props.children
                  })
            });
}

var Label = {
  make: LotCardPrice$Label
};

function LotCardPrice$Value(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return React.createElement(PropSpread$LiveRoom.make, {
              data: {
                hd: {
                  TAG: /* TestId */1,
                  _0: props.testId
                },
                tl: /* [] */0
              },
              children: React.createElement(SterlingTypography$LiveRoom.Paragraph14Regular.make, {
                    className: Curry._1(Css.merge, {
                          hd: Curry._1(Css.style, {
                                hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                                tl: {
                                  hd: Css.textAlign("right"),
                                  tl: /* [] */0
                                }
                              }),
                          tl: {
                            hd: className$1,
                            tl: /* [] */0
                          }
                        }),
                    children: props.children
                  })
            });
}

var Value = {
  make: LotCardPrice$Value
};

function LotCardPrice$Subvalue(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return React.createElement(PropSpread$LiveRoom.make, {
              data: {
                hd: {
                  TAG: /* TestId */1,
                  _0: props.testId
                },
                tl: /* [] */0
              },
              children: React.createElement(SterlingTypography$LiveRoom.Paragraph12Regular.make, {
                    className: Curry._1(Css.merge, {
                          hd: Curry._1(Css.style, {
                                hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey80_nohashtag)),
                                tl: {
                                  hd: Css.textAlign("right"),
                                  tl: /* [] */0
                                }
                              }),
                          tl: {
                            hd: className$1,
                            tl: /* [] */0
                          }
                        }),
                    children: props.children
                  })
            });
}

var Subvalue = {
  make: LotCardPrice$Subvalue
};

var estimateTextColor = Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey80_nohashtag);

function LotCardPrice$Estimate$EstimateUponRequest(props) {
  var match = I18next$LiveRoom.useTranslation(undefined);
  return React.createElement(LotCardPrice$Label, {
              className: Curry._1(Css.style, {
                    hd: Css.color(estimateTextColor),
                    tl: {
                      hd: Css.textAlign("right"),
                      tl: /* [] */0
                    }
                  }),
              children: Curry._1(match.t, "Common_lotEstimateUponRequest"),
              testId: "lotEstimateUponRequest"
            });
}

var EstimateUponRequest = {
  make: LotCardPrice$Estimate$EstimateUponRequest
};

var formatNumber = Utils_Shared$LiveRoom.Numbers.withCommas;

function LotCardPrice$Estimate$LotEstimate(props) {
  var lowEstimate = props.lowEstimate;
  var highEstimate = props.highEstimate;
  var alternativeCurrency = Curry._1(AlternativeCurrency$LiveRoom.Context.use, undefined);
  var match = lowEstimate.currency;
  var match$1 = highEstimate.currency;
  var currency = match !== undefined ? Amount$LiveRoom.currencyToString(match) : (
      match$1 !== undefined ? Amount$LiveRoom.currencyToString(match$1) : ""
    );
  var lowEstimateStr = Curry._1(formatNumber, lowEstimate.amount);
  var highEstimateStr = Curry._1(formatNumber, highEstimate.amount);
  var tmp;
  if (alternativeCurrency !== undefined && !props.isLotClosed) {
    var rate = alternativeCurrency.rate;
    var lowEstimate$1 = AlternativeCurrency$LiveRoom.formatAlternativeCurrency(lowEstimate.amount, rate);
    var highEstimate$1 = AlternativeCurrency$LiveRoom.formatAlternativeCurrency(highEstimate.amount, rate);
    var currency$1 = Amount$LiveRoom.currencyToString(alternativeCurrency.currency);
    tmp = React.createElement(LotCardPrice$Subvalue, {
          children: "" + lowEstimate$1 + " - " + highEstimate$1 + " " + currency$1 + "",
          testId: "lotEstimateSubValue"
        });
  } else {
    tmp = null;
  }
  return React.createElement(React.Fragment, undefined, React.createElement(LotCardPrice$Value, {
                  className: Curry._1(Css.style, {
                        hd: Css.color(estimateTextColor),
                        tl: /* [] */0
                      }),
                  children: "" + lowEstimateStr + " - " + highEstimateStr + " " + currency + "",
                  testId: "lotEstimateValue"
                }), tmp);
}

var LotEstimate = {
  formatNumber: formatNumber,
  make: LotCardPrice$Estimate$LotEstimate
};

function LotCardPrice$Estimate(props) {
  var estimate = props.estimate;
  var variant = estimate.NAME;
  if (variant !== "LowHighEstimateV2") {
    if (variant === "FutureAddedValue") {
      return null;
    } else {
      return React.createElement(LotCardPrice$Estimate$EstimateUponRequest, {});
    }
  }
  var match = estimate.VAL;
  return React.createElement(LotCardPrice$Estimate$LotEstimate, {
              highEstimate: match.highEstimate,
              lowEstimate: match.lowEstimate,
              isLotClosed: props.isLotClosed
            });
}

var Estimate = {
  estimateTextColor: estimateTextColor,
  EstimateUponRequest: EstimateUponRequest,
  LotEstimate: LotEstimate,
  make: LotCardPrice$Estimate
};

function LotCardPrice$LotAmountSold(props) {
  var fallback = props.fallback;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var match$1 = Belt_Option.flatMap(props.premiums, (function (p) {
          return p.finalPrice;
        }));
  if (!props.isSold) {
    return fallback;
  }
  if (match$1 === undefined) {
    return fallback;
  }
  var amount = Amount$LiveRoom.format(match$1.amount);
  var currency = Amount$LiveRoom.currencyToString(match$1.currency);
  return React.createElement(LotCardPrice$Layout, {
              children: null
            }, React.createElement(LotCardPrice$Label, {
                  className: Curry._1(Css.style, {
                        hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey80_nohashtag)),
                        tl: /* [] */0
                      }),
                  children: Curry._1(match.t, "LotSold"),
                  testId: "lotAmountSold"
                }), React.createElement(LotCardPrice$Value, {
                  children: "" + amount + " " + currency + "",
                  testId: "lotAmountSoldValue"
                }));
}

var LotAmountSold = {
  make: LotCardPrice$LotAmountSold
};

function LotCardPrice$LotAmount$AlternativeLotAmount(props) {
  var amountConverted = AlternativeCurrency$LiveRoom.formatAlternativeCurrency(props.amount, props.rate);
  var currency = Amount$LiveRoom.currencyToString(props.alternativeCurrency);
  return React.createElement(LotCardPrice$Subvalue, {
              children: "" + amountConverted + " " + currency + "",
              testId: "lotAmountValue"
            });
}

var AlternativeLotAmount = {
  make: LotCardPrice$LotAmount$AlternativeLotAmount
};

function LotCardPrice$LotAmount(props) {
  var bidState = props.bidState;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  var alternativeCurrency = Curry._1(AlternativeCurrency$LiveRoom.Context.use, undefined);
  var match$1 = bidState.startingBid;
  var match$2 = bidState.currentBid;
  if (match$1 !== undefined && match$2 === undefined) {
    var amount = match$1.amount;
    var displayAmount = Amount$LiveRoom.format(amount);
    var currency = Amount$LiveRoom.currencyToString(match$1.currency);
    return React.createElement(LotCardPrice$Layout, {
                children: null
              }, React.createElement(LotCardPrice$Label, {
                    children: Curry._1(t, "StartingBid"),
                    testId: "startingBid"
                  }), React.createElement("div", undefined, React.createElement(LotCardPrice$Value, {
                        children: "" + displayAmount + " " + currency + "",
                        testId: "lotAmountValue"
                      }), alternativeCurrency !== undefined ? React.createElement(LotCardPrice$LotAmount$AlternativeLotAmount, {
                          amount: amount,
                          rate: alternativeCurrency.rate,
                          alternativeCurrency: alternativeCurrency.currency
                        }) : null));
  }
  if (match$2 === undefined) {
    return props.fallback;
  }
  var amount$1 = match$2.amount;
  var displayAmount$1 = Amount$LiveRoom.format(amount$1);
  var currency$1 = Amount$LiveRoom.currencyToString(match$2.currency);
  return React.createElement(LotCardPrice$Layout, {
              children: null
            }, React.createElement(LotCardPrice$Label, {
                  children: Curry._1(t, "CurrentBid"),
                  testId: "currentBid"
                }), React.createElement("div", undefined, React.createElement(LotCardPrice$Value, {
                      children: "" + displayAmount$1 + " " + currency$1 + "",
                      testId: "currentBidValue"
                    }), alternativeCurrency !== undefined ? React.createElement(LotCardPrice$LotAmount$AlternativeLotAmount, {
                        amount: amount$1,
                        rate: alternativeCurrency.rate,
                        alternativeCurrency: alternativeCurrency.currency
                      }) : null));
}

var LotAmount = {
  AlternativeLotAmount: AlternativeLotAmount,
  make: LotCardPrice$LotAmount
};

function LotCardPrice(props) {
  var fallback = props.fallback;
  var bidState = props.bidState;
  var fallback$1 = fallback !== undefined ? Caml_option.valFromOption(fallback) : null;
  var match = bidState.isClosed;
  var match$1 = bidState.sold;
  if (match) {
    if (match$1 === undefined) {
      return fallback$1;
    }
    if (typeof match$1 !== "object") {
      return fallback$1;
    }
    var variant = match$1.NAME;
    if (variant !== "ResultVisible") {
      return fallback$1;
    }
    var match$2 = match$1.VAL;
    return React.createElement(LotCardPrice$LotAmountSold, {
                isSold: match$2.isSold,
                premiums: match$2.premiums,
                fallback: fallback$1
              });
  }
  var match$3 = bidState.bidType;
  if (typeof match$3 !== "object") {
    return fallback$1;
  }
  if (match$3.NAME !== "LiveBidType") {
    return fallback$1;
  }
  var match$4 = match$3.VAL.liveBidPhase;
  if (match$4 === "Live" || match$4 === "ConfirmingResult") {
    return React.createElement(LotCardPrice$LotAmount, {
                bidState: bidState,
                fallback: fallback$1
              });
  } else {
    return fallback$1;
  }
}

var make = LotCardPrice;

export {
  Layout ,
  Label ,
  Value ,
  Subvalue ,
  Estimate ,
  LotAmountSold ,
  LotAmount ,
  make ,
}
/* estimateTextColor Not a pure module */
